import { FC } from 'react';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import * as S from './styled';

/**
 * Accepts both a full company and a lightweight autocomplete suggestion — only the logo, name,
 * industry and country are read.
 */
type TCompanyCardCompany = {
  name?: string | null;
  logo?: { link?: string | null } | null;
  logoUrl?: string | null;
  effectiveLogoUrl?: string | null;
  industryRaw?: string | null;
  country?: string | null;
};

type TCompanyCardProps = {
  company: TCompanyCardCompany;
  /** When passed, the card becomes clickable and lifts on hover. */
  onClick?: () => void;
};

const CompanyCard: FC<TCompanyCardProps> = ({ company, onClick }) => {
  const logoSrc = company.logo?.link || company.logoUrl || company.effectiveLogoUrl || undefined;
  // The logo may be missing (or its URL broken) — Avatar then falls back to the monogram.
  const monogram = company.name?.charAt(0)?.toUpperCase() || '?';

  return (
    <S.Card onClick={onClick} isInteractive={!!onClick}>
      <S.Logo src={logoSrc} alt={company.name || ''} variant="rounded" hasImage={!!logoSrc}>
        {monogram}
      </S.Logo>

      <S.CardName>{company.name}</S.CardName>

      <S.CardMeta>
        {company.industryRaw && <S.Tag>{company.industryRaw}</S.Tag>}

        {company.country && (
          <S.MetaItem>
            <LocationOnIcon fontSize="small" />
            {company.country}
          </S.MetaItem>
        )}
      </S.CardMeta>
    </S.Card>
  );
};

export default CompanyCard;
